<script lang="ts" setup>
	import {FormElementGrid} from '@/scripts/types/generated';

	const $props = defineProps<Partial<FormElementGrid>>();

	let columns: string;

	switch ($props.columns) {
		case 1:
			columns = 'lg:grid-cols-1';
			break;
		case 2:
			columns = 'lg:grid-cols-2';
			break;
		case 3:
			columns = 'lg:grid-cols-3';
			break;
		case 4:
			columns = 'lg:grid-cols-4';
			break;
		default:
			columns = 'lg:grid-cols-1';
	}
</script>

<template>
	<FormElementWrapper
		:columns="$props.columns"
		v-bind="$props"
	>
		<div
			:class="['grid grid-cols-1 gap-x-4 gap-y-2', columns]"
			v-bind="$attrs"
		>
			<slot />
		</div>
	</FormElementWrapper>
</template>
